<form>
  <mat-form-field class="full-width" [style.width]="width" [subscriptSizing]="heightSizing">
    <mat-label>{{placeholder && !selectedItem.value && !isFocused ? placeholder : label}}</mat-label>
    <input type="text" #input matInput [formControl]="selectedItem" [matAutocomplete]="auto"
      spellcheck="false" (focus)="isFocused = true" (blur)="isFocused = false">
      @if (selectedItem.value) {
        <button class="reset-btn" matSuffix mat-icon-button aria-label="Clear"
          (click)="onResetSelection()">
          <mat-icon>close</mat-icon>
        </button>
      }
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="dispalyName" panelWidth="auto"
        class="app-autocomplete-panel" classList="app-autocomplete-panel"
        (optionSelected)="onItemSelected($event.option.value)" (closed)="onPanelClosed()">
        <!-- grouped items -->
        @if (groupedItems) {
          @for (group of groupedFilteredOptions | async; track group) {
            <mat-optgroup [label]="group.groupName">
              @for (option of group.items; track option) {
                <mat-option class='option-text' [value]="option">
                  {{option.name}}
                </mat-option>
              }
            </mat-optgroup>
          }
        }
        <!-- non grouped items -->
        @if (!groupedItems) {
          @for (option of filteredOptions | async; track option) {
            <mat-option class='option-text' [value]="option">
              {{option.name}}
            </mat-option>
          }
        }
        @if (isFilteredEmpty) {
          <mat-option [value]="null" [disabled]="true" translate>Not found</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </form>